import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

import { AdvancedSearchSandboxService } from '@mediahaven/shared';
import { ExtendedProfileField, OrganisationId, User } from '@stylehaven/components';
import { uniqWith } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class PublicAdvancedSearchSandboxService extends AdvancedSearchSandboxService {
    private readonly PORTAL_SEARCH_TAG: string = 'Mh2.Portal.Search';
    private readonly DEFAULT_ADVANCED_SEARCH_TAG: string = 'Mh2.Search';

    public getProfileFieldsStream(): Observable<ExtendedProfileField[]> {
        return this.userStoreService.getCurrentUser().pipe(
            map((user: User) => user.Organisation.Id),
            switchMap(orgId => this.getAdvancedSearchProfileFields(orgId)),
            map(fields => fields.filter(field => field.Public)),
            map(fields =>
                uniqWith(
                    fields,
                    (field1: ExtendedProfileField, field2: ExtendedProfileField) =>
                        field1.FieldDefinition.DottedKey === field2.FieldDefinition.DottedKey
                )
            ),
            shareReplay(1)
        );
    }

    // Backwards compatibility in case the migration is still running
    private getAdvancedSearchProfileFields(orgId: OrganisationId): Observable<ExtendedProfileField[]> {
        return this.profileService
            .getAdvancedSearchProfileFields(orgId, this.PORTAL_SEARCH_TAG)
            .pipe(
                switchMap(fields =>
                    fields.length > 0
                        ? of(fields)
                        : this.profileService.getAdvancedSearchProfileFields(orgId, this.DEFAULT_ADVANCED_SEARCH_TAG)
                )
            );
    }
}
